import Vue from 'vue'
import VueRouter from 'vue-router'
import { BASE_URL } from '@/config/environment'

Vue.use(VueRouter)

const routes = [
  {
    path: '/unauthorized',
    name: 'unauthorized',
    component: () => import(/* webpackChunkName: "unauthorized" */ '../views/Unauthorized.vue')
  },
  {
    path: '/main/:token',
    name: 'main',
    component: () => import(/* webpackChunkName: "main" */ '../views/Main.vue'),
    meta: { icon: 'local_hotel' }
  },
  {
    path: '*',
    redirect: { name: 'main' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: BASE_URL,
  routes
})

export default router
